var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as actions from '../constants';
import { saveTeamToCookie, getCurrentTeamId } from '../helpers'; // Initial State

var initialState = {
  byId: {},
  order: [],
  currentTeam: undefined,
  hasFetched: false
};
export var teams = function teams() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var currentTeam = void 0;

  switch (action.type) {
    case actions.USER_TEAMS_LOAD_REQUEST:
      return _extends({}, state, {
        hasFetched: false
      });

    case actions.USER_TEAMS_LOAD_SUCCESS:
      // Check if user has teams
      if (action.payload.order.length > 0) {
        // Check if current team is set in state
        if (state.currentTeam) {
          currentTeam = state.currentTeam; // Check if current team is set in cookie
        } else if (getCurrentTeamId()) {
          currentTeam = getCurrentTeamId();
        } // Check if user belongs to current team


        if (!currentTeam || !action.payload.order.find(function (t) {
          return t === Number(currentTeam);
        })) {
          currentTeam = action.payload.order[0];
        }

        if (currentTeam) {
          saveTeamToCookie(currentTeam.toString());
        }
      } else {
        currentTeam = null;
        saveTeamToCookie('0');
      }

      return _extends({}, state, action.payload, {
        currentTeam: currentTeam,
        hasFetched: true
      });

    case actions.USER_TEAMS_LOAD_FAILURE:
      return _extends({}, state, {
        hasFetched: true
      });

    case actions.USER_TEAM_CHANGE:
      saveTeamToCookie(action.currentTeam.toString());
      return _extends({}, state, {
        currentTeam: action.currentTeam
      });

    case actions.USER_ORGANISATION_CHANGE:
      return initialState;

    case actions.LOG_OUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};
export var getTeamById = function getTeamById(state, props) {
  return state.auth.teams.byId[props.match.params.mapId];
};